


























































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import FlightSearchInput from '@/store/entities/flight/flightSearchInput';
import FlightSearchList from '@/store/entities/flight/flightSearchList';
import AirlineCompany from '@/store/entities/flight/airlineCompany';
import moment from 'moment-timezone';
import Airport from '@/store/entities/airport';
import FlightSearchs from '@/store/entities/flight/flightSearch';
import Flight from '@/store/entities/flight/flight';
import ajax from '@/lib/ajax';
@Component({
  components: { HeaderHome: () => import('@/components/headerhome.vue') },
})
export default class FlightSearch extends Vue {
  startDate: string = null;
  endDate: string = null;
  adultCount: number = 1;
  childCount: number = 0;
  infantCount: number = 0;
  show: boolean = false;
  show1: boolean = true;
  show2: boolean = true;
  show3: boolean = false;
  show4: boolean = false;
  show5: boolean = false;
  show6: boolean = false;
  show7: boolean = true;
  radios: boolean = true;
  radios1: boolean = true;
  radios2: boolean = true;
  radios3: boolean = true;
  radios4: boolean = true;
  flightSearchInput: FlightSearchInput = new FlightSearchInput();
  flightSearchList: FlightSearchList[] = [];
  auxSearchList: FlightSearchList[] = [];
  selectedAirline: any[] = [];
  slider = 0;
  hours1: string | number;
  minutes1: string | number;
  hours2: string | number;
  icons: any = ['mdi-snowflake', 'mdi-leaf', 'mdi-fire', 'mdi-water'];
  seasons: any = ['Winter', 'Spring', 'Summer', 'Fall'];
  minutes2: string | number;
  range: any = [0, 48];
  min = 0;
  max = 48;
  priceValue = null;
  minPrice: number = 0;
  maxPrice: number = 0;
  times: any = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '9:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30',
    '23:59',
  ];
  inputTimes: any = [];
  airlineList: AirlineCompany[] = [];
  serviceAirlineList: AirlineCompany[] = [];
  flightSearchArray: FlightSearchInput[] = [];
  flightSearch: FlightSearchs = new FlightSearchs();
  airports: Airport[] = [];
  flightList: Flight[] = [];
  auxFlightList: Flight[] = [];
  array: any[] = [];
  request: any = {};
  startTimeMenu: boolean = false;
  endTimeMenu: boolean = false;
  disabled: boolean = true;
  nowDate: string = new Date().toISOString().slice(0, 10);
  endDateStart: string = '';
  searchId: string;
  getFromAirportsRequestObject: any = {};
  getToAirportsRequestObject: any = {};
  loadingFromAirport: boolean = false;
  loadingToAirport: boolean = false;
  searchFromInput: string = '';
  searchToInput: string = '';
  fromAirports: Airport[] = [];
  toAirports: Airport[] = [];
  fromAirport: any = {};
  toAirport: any = {};
  isLoading: boolean = false;
  currency = 'EUR';
  newPrice: string;
  oldPrice: string;
  computedPrice: any = {};

  get getLanguage(){
    
   return this.$root.$i18n.locale;
  }


  async created() {
    this.isLoading = true;
    this.season([0, 48]);
    this.searchId = this.$route.params.id;

    await this.$store.dispatch({
      type: 'flight/getFlightSearchResults',
      data: this.$route.params.id,
    });

    this.flightSearchList = this.$store.state.flight.list;
    this.flightList = this.$store.state.flight.list[0].flights;
    this.flightList = Object.assign([], this.flightList);
    this.flightList.sort((a, b) => {
     
  if (a[0].totalPrice < b[0].totalPrice) {
 
  
    return -1;
  }
  if (a[0].totalPrice > b[0].totalPrice) {
   
    return 1;
  }
});


    this.flightList.map((item: any) => {
      item.map((x) => {
        this.priceFormatter(x.totalPrice, x.totalPriceCurrencyId).then(
          (res) => {
            x.totalPrice = res.total;
            x.totalPriceCurrencyId = res.secondCurrencyId;
          }
        );
      });
    });

    this.maxPrice = Math.max(
      ...this.flightList
        .flatMap((item: any) => item)
        .map(({ totalPrice }) => totalPrice)
    );

    this.request = this.$store.state.flight.list[0].request;
    this.adultCount = this.request.adultCount;
    this.childCount = this.request.childCount;
    this.infantCount = this.request.infantCount;

    await this.$store.dispatch({
      type: 'airport/getFromAirports',
      data: { name: this.request.fromAirportId },
    });

    await this.$store.dispatch({
      type: 'airport/getToAirports',
      data: { name: this.request.toAirportId },
    });

    this.airlineList = this.$store.state.flight.list[0].airlines;
    

    for (let i = 0; i < this.airlineList.length; i++) {
      this.selectedAirline.push(this.airlineList[i].name);
    }

    this.startDate = moment(this.request.departureDate).format();
    if (this.request.arrivalDate) {
      this.endDate = moment(this.request.arrivalDate).format();
    }
    this.endDateStart = moment(this.startDate)
      .add(2, 'days')
      .toISOString()
      .slice(0, 10);
    this.isLoading = false;

    await this.setAirports();
  }

    formatFlightDuration(duration) {
      debugger;
         const [h, m] = duration.split('.');

      // Zaten doğru formatta ise düzenleme yapmadan döndür
      if (h.length === 2 && m.length === 2) {
          return `${h}: ${m}`;
      }

      const hours = "0" +h;
      const minutes = "0" +m
      return `${hours}: ${minutes}`;
    }

  async searchFlight() {
    this.isLoading = true;
    this.flightSearchArray = [];
    this.selectedAirline = [];
    this.flightSearchInput.clientDepartureDate = moment(this.startDate).format(
      'DD-MM-yyyy'
    );
    this.flightSearchInput.clientArrivalDate = this.endDate
      ? moment(this.endDate).format('DD-MM-yyyy')
      : '';
    this.flightSearchInput.departureDate = moment(this.startDate).format(
      'DD-MM-yyyy'
    );
    this.flightSearchInput.arrivalDate = this.endDate
      ? moment(this.endDate).format('DD-MM-yyyy')
      : '';
    this.flightSearchInput.adultCount = this.adultCount;
    this.flightSearchInput.childCount = this.childCount;
    this.flightSearchInput.infantCount = this.infantCount;
    this.flightSearchInput.flightType = this.flightSearchInput.arrivalDate
      ? 'RTF'
      : 'OWF';
    this.flightSearchInput.flightSearchType = this.flightSearchInput
      .clientArrivalDate
      ? 1
      : 0;
    this.flightSearchInput.refId = 189;
    this.flightSearchInput.currencyId = this.$store.state.currency.id;
    this.flightSearchArray.push(this.flightSearchInput);
    this.flightSearch.flightSearchInputs = this.flightSearchArray;
    this.flightSearch.saleChannelId = 'INTERNET';

    let response = await this.$store.dispatch({
      type: 'flight/searchFlight',
      data: this.flightSearch,
    });

    await this.$store.dispatch({
      type: 'flight/getFlightSearchResults',
      data: response,
    });
    this.searchId = response;
    this.$router.push('/flightSearch/' + response);
    this.flightSearchList = this.$store.state.flight.list;
    this.flightList = this.$store.state.flight.list[0].flights;
    this.flightList = Object.assign([], this.flightList);
    this.request = this.$store.state.flight.list[0].request;
    this.adultCount = this.request.adultCount;
    this.childCount = this.request.childCount;
    this.infantCount = this.request.infantCount;
    this.airlineList = this.$store.state.flight.list[0].airlines;
    for (let i = 0; i < this.airlineList.length; i++) {
      this.selectedAirline.push(this.airlineList[i].name);
    }
    this.isLoading = false;
  }
  async setAirports() {
    if (this.$store.state.airport.fromAirportlist.length > 0) {
      this.fromAirports = this.$store.state.airport.fromAirportlist;
      this.toAirports = this.$store.state.airport.toAirportlist;
      let fromAirport = this.$store.state.airport.fromAirportlist[0];
      let toAirport = this.$store.state.airport.toAirportlist[0];
      this.searchFromInput = fromAirport.fullAirportName;
      this.searchToInput = toAirport.fullAirportName;
      this.flightSearchInput.fromAirport = fromAirport;
      this.flightSearchInput.toAirport = toAirport;
    }
  }
  async getFromAirportsForAutoComplete() {
    this.loadingFromAirport = true;
    await this.$store.dispatch({
      type: 'airport/getFromAirports',
      data: this.getFromAirportsRequestObject,
    });
    this.fromAirports = this.$store.state.airport.fromAirportlist;
    this.loadingFromAirport = false;
  }

  async getToAirportsForAutoComplete() {
    this.loadingToAirport = true;
    await this.$store.dispatch({
      type: 'airport/getToAirports',
      data: this.getToAirportsRequestObject,
    });
    this.toAirports = this.$store.state.airport.toAirportlist;
    this.loadingToAirport = false;
  }

  get getSearchFromInput() {
    return this.searchFromInput;
  }

  set getSearchFromInput(value) {
    if (value && value.length > 0 && value.length >= 3 && value.length < 4) {
      this.getFromAirportsRequestObject.name = value;
      this.getFromAirportsForAutoComplete();
    }
  }

  get getSearchToInput() {
    return this.searchToInput;
  }

  set getSearchToInput(value) {
    if (value && value.length > 0 && value.length >= 3 && value.length < 4) {
      this.getToAirportsRequestObject.name = value;
      this.getToAirportsForAutoComplete();
    }
  }

  cityFormatName(text: string) {
    debugger;
    const searchTerm = ',';
    const indexOfFirstTerm = text.indexOf(searchTerm);
    const slicesText = text.slice(0, indexOfFirstTerm);
    return slicesText;
  }

  filterFlightsByAirline(flights: Flight[]) {
    return this.selectedAirline && this.selectedAirline.length
      ? flights.filter(
          (flight) => this.selectedAirline.indexOf(flight[0].airlineName) !== -1
        )
      : flights;
  }

  filterFlightsByRangeTime(flights: Flight[]) {
    const value1 = this.inputTimes[0];
    const value2 = this.inputTimes[1];

    return flights
      .filter((x) => value1 <= x[0].departureHour)
      .filter((y) => y[0].departureHour <= value2);
  }

  filterFlightsByPrice(flights: Flight[]) {
    return flights.filter((x) => x[0].totalPrice >= this.priceValue);
  }

  get maximumPrice() {
    if (this.flightList.length > 0) {
      return Math.max(
        ...this.flightList
          .flatMap((item: any) => item)
          .map(({ totalPrice }) => totalPrice.toFixed(0))
      );
    }
    return 1;
  }
  async priceFormatter(price, currencyId) {
    if (this.newPrice !== undefined && this.oldPrice === undefined) {
      const payload = {
        amount: price,
        firstCurrencyId: currencyId,
        secondCurrencyId: this.$store.state.currency.id,
      };
      const response = await ajax.post(
        '/api/services/app/Booking/ConvertExchangeRate',
        payload
      );
      return response.data.result;
    }

    const payload = {
      amount: price,
      firstCurrencyId: currencyId,
      secondCurrencyId: this.newPrice,
    };
    const response = await ajax.post(
      '/api/services/app/Booking/ConvertExchangeRate',
      payload
    );
    return response.data.result;
  }

  async changeFlightList() {
    await this.flightList.map((item: any) => {
      item.map((x) => {
        this.priceFormatter(x.totalPrice, x.totalPriceCurrencyId).then(
          (res) => {
            x.totalPrice = res.total;
            x.totalPriceCurrencyId = res.secondCurrencyId;
          }
        );
      });
    });
  }

  endDateEvents(event) {
    if (new Date(event) <= new Date(this.startDate)) {
      alert('Dönüş Zamanı gidiş zamanından ileri tarih olmalıdır!');
      this.endDate = '';
    }
  }

  returnEvents(e) {
    this.disabled = false;
  }

  async addBasketFlight(flightId, returnFlightId = '') {
    if (returnFlightId === '') {
      this.$router.push('/flightPayment/' + this.searchId + '/' + flightId+"?currency="+this.currencyFormat);
    } else {
      this.$router.push(
        '/flightPayment/' +
          this.searchId +
          '/' +
          flightId +
          '/' +
          returnFlightId+"?currency="+this.currencyFormat
      );
    }
  }

  changeAirport() {
    let fromAirports = this.fromAirports;
    let toAirports = this.toAirports;
    this.toAirports = fromAirports;
    this.fromAirports = toAirports;
    let fromAirport = this.flightSearchInput.fromAirport;
    let toAirport = this.flightSearchInput.toAirport;
    this.flightSearchInput.fromAirport = toAirport;
    this.flightSearchInput.toAirport = fromAirport;
    let fromAirportInput = this.searchFromInput;
    let toAirportInput = this.searchToInput;
    this.searchToInput = fromAirportInput;
    this.searchFromInput = toAirportInput;
  }

  season(val) {
    const array = [this.times[val[0]], this.times[val[1]]];
    this.inputTimes = array;
  }

  onHandleChangePrice(val) {
    this.priceValue = val;
  }
  plusAdultCount() {
    if (this.adultCount < 9) this.adultCount += 1;
  }

  minusAdultCount() {
    if (this.adultCount != 1) this.adultCount -= 1;
  }

  plusChildCount() {
    if (this.childCount < 9) this.childCount += 1;
  }
  minusChildCount() {
    if (this.childCount != 0) this.childCount -= 1;
  }
  plusInfantCount() {
    if (this.infantCount < 9) this.infantCount += 1;
  }
  minusInfantCount() {
    if (this.infantCount != 0) this.infantCount -= 1;
  }

  get filterByFlights() {
    return this.filterFlightsByAirline(
      this.filterFlightsByRangeTime(this.filterFlightsByPrice(this.flightList))
    );
  }

  get getRange() {
    return;
  }
  get currencyFormat() {
    this.slider = 0;
    return this.$store.state.currency.id;
  }

  set currencyFormat(value) {
    this.newPrice = value;
  }

  @Watch('startDate')
  onChangeStartDate(val) {
    this.endDateStart = moment(val)
      .add(2, 'days')
      .toISOString()
      .slice(0, 10);
  }

  @Watch('currencyFormat', { immediate: true })
  onChangeCurrencyFormat(price, oldPrice) {
    this.newPrice = price;
    this.oldPrice = oldPrice;
    this.changeFlightList();
  }

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format('DD-MM-yyyy') : '';
  }
  set getEndDate(value) {
    this.endDate = value;
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format('DD-MM-yyyy') : '';
  }

  get totalPassengerCount() {
    return this.adultCount + this.childCount + this.infantCount;
  }
}
